;
(function ($) {
  var dataKey = 'app.cookiePolicy';
  var CookiePolicy = function CookiePolicy(element, options) {
    this.element = element;
    this.init(options);
  };
  CookiePolicy.prototype = {
    values: {
      delay: 1000,
      cookieName: 'CookiePolicy',
      cookieValue: 'Closed'
    },
    attr: {
      close: 'data-policy-close',
      footer: 'data-footer'
    },
    classes: {
      open: 'cookie-policy--open',
      visible: 'cookie-policy--visible'
    },
    /**
     * Initialise Cookie Policy
     * Waits to see if a cookie exists or not to hide or show the cookie policy banner.
     * @public
     * @constructor
     * @param {string} options - Apply and extend options into init if needed.
     */

    init: function init(options) {
      $.extend(this.options, options);
      if (!this._checkCookiePolicy()) {
        this._showCookiePolicy(this.element);
      }
    },
    /**
     * Show Cookie Policy
     * Shows the policy so the user can tab to the links for accessibility.
     * Animates the policy onto the screen so the banner can be seen.
     * @private
     * @param {string} elm - The element that initialised the plugin.
     */

    _showCookiePolicy: function _showCookiePolicy(elm) {
      var _this = this;
      $(elm).show();
      setTimeout(function () {
        $(elm).addClass(_this.classes.visible);
        _this._addFooterSpacing();
        _this._onClosePolicy();
      }, this.values.delay);
    },
    /**
     * On Close Policy
     * Listens for a mouse click on the close button.
     * Listens for a keypress (spacebar) on the close button. This is for accessibility purposes.
     * @private
     */

    _onClosePolicy: function _onClosePolicy() {
      var _this = this;
      $('[' + this.attr.close + ']').on('click', function () {
        $(_this.element).removeClass(_this.classes.visible);
        _this._removeFooterSpacing();
        _this._setSessionCookie();
      });
      $('[' + this.attr.close + ']').bind('keypress', function (e) {
        if (e.keyCode === 32) {
          $(_this.element).removeClass(_this.classes.visible);
          _this._removeFooterSpacing();
          _this._setSessionCookie();
          return false;
        }
      });
    },
    /**
     * Add Footer Spacing
     * Adds additional spacing to the bottom of the footer to stop the cookie policy banner overlaying any content.
     * @private
     */

    _addFooterSpacing: function _addFooterSpacing() {
      $('[' + this.attr.footer + ']').addClass(this.classes.open);
    },
    /**
     * Remove Footer Spacing
     * Removes the additiona footer spacing once the cookie policy banner is closed.
     * @private
     */

    _removeFooterSpacing: function _removeFooterSpacing() {
      $('[' + this.attr.footer + ']').removeClass(this.classes.open);
    },
    /**
     * Set Session Cookie
     * Adds a new session cookie to the browser to prevent the banner re-opening on every page load.
     * @private
     */

    _setSessionCookie: function _setSessionCookie() {
      document.cookie = this.values.cookieName + '=' + this.values.cookieValue;
    },
    /**
     * Check Cookie Policy
     * Checks to see if a session cookie already exists before trying to show the cookie policy banner.
     * @private
     */

    _checkCookiePolicy: function _checkCookiePolicy() {
      var match = document.cookie.match(new RegExp('(^| )' + this.values.cookieName + '=([^;]+)'));
      var validate = match ? true : false;
      return validate;
    }
  };

  /**
   * Global callback function which by default all [data-cookie-policy] triggers this plugin.
   * @method $.fn.app_cookiePolicy()
   * @public
   * @constructor
   * @param {string} options
   * @optional options
   * @example $(element).app_cookiePolicy();
   */

  $.fn.app_cookiePolicy = function (options) {
    var plugin = this.data(dataKey);
    if (plugin instanceof CookiePolicy) {
      if (typeof options !== 'undefined') {
        plugin.init(options);
      }
    } else {
      plugin = new CookiePolicy(this, options);
      this.data(dataKey, plugin);
    }
    return plugin;
  };
})(jQuery, window, document);